var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97181 11.4589C4.4516 11.4589 3.15957 10.9262 2.09574 9.86073C1.03191 8.79528 0.5 7.50152 0.5 5.97945C0.5 4.45738 1.03191 3.16362 2.09574 2.09817C3.15957 1.03272 4.45137 0.5 5.97112 0.5C7.49088 0.5 8.78267 1.03272 9.8465 2.09817C10.9103 3.16362 11.4422 4.45761 11.4422 5.98014C11.4422 6.5949 11.3473 7.17466 11.1573 7.71941C10.9673 8.26415 10.7052 8.76484 10.3708 9.22146L15.2492 14.1073C15.4164 14.2747 15.5 14.465 15.5 14.6781C15.5 14.8912 15.4164 15.0814 15.2492 15.2489C15.0821 15.4163 14.8883 15.5 14.6679 15.5C14.4476 15.5 14.2538 15.4163 14.0866 15.2489L9.20821 10.3858C8.75228 10.7207 8.25236 10.9833 7.70843 11.1735C7.16451 11.3638 6.58564 11.4589 5.97181 11.4589ZM5.97112 9.81507C7.03495 9.81507 7.93921 9.44216 8.68389 8.69635C9.42857 7.95053 9.80091 7.0449 9.80091 5.97945C9.80091 4.914 9.42857 4.00837 8.68389 3.26256C7.93921 2.51674 7.03495 2.14384 5.97112 2.14384C4.90729 2.14384 4.00304 2.51674 3.25836 3.26256C2.51368 4.00837 2.14134 4.914 2.14134 5.97945C2.14134 7.0449 2.51368 7.95053 3.25836 8.69635C4.00304 9.44216 4.90729 9.81507 5.97112 9.81507Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.df38c5bd407b252e62a10e689f2380aa.svg";
export { ForwardRef as ReactComponent };